module.exports = __webpack_public_path__ + "static/media/hongdanshan2.17ee2f84.jpeg";